<template>
  <div>
    <hero-bar>
      Users
    </hero-bar>
    <section class="section is-main-section">
      <card-component title="" icon="ballot">
        <div class="column is-one-half" style="margin:2%;margin-top:2%;">
        <div class="control">
          <b-button @click="newUser">New User</b-button>
        </div>
      </div>
      <b-table :data="users" :columns="columns" :paginated="isPaginated" :per-page="perPage" @click="selectUser"></b-table>
      </card-component>
    </section>
</div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import axios from 'axios'
import HeroBar from '@/components/HeroBar'
export default {
  name: 'Forms',
  components: { HeroBar, CardComponent },
  data () {
    return {
      users: [],
      isPaginated: true,
      perPage: 10,
      columns: [
        { field: 'name', label: 'Name', width: '40', searchable: true },
        { field: 'surname', label: 'Surname', width: '40', searchable: true },
        { field: 'email', label: 'Email', width: '40', searchable: true },
        { field: 'role', label: 'Role', width: '20' },
        { field: 'agency', label: 'Agency', width: '10' },
        { field: 'active', label: 'Active', width: '10' }
      ]
    }
  },
  computed: {
  },
  methods: {
    async getUsers () {
      try {
        const { data } = await axios.get(this.$store.state.apiUrl + 'user', {
          headers: {
            Authorization: 'Bearer ' + this.$cookies.get('user_token'),
            'Content-Type': 'application/json'
          }
        })
        var i = 0
        for (i = 0; i < data.length; i++) {
          this.users.push({
            name: data[i].name, surname: data[i].surname, email: data[i].email, role: data[i].role, agency: data[i].agency, active: data[i].active === true ? 'Y' : 'N'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    selectUser (record) {
      this.$router.push({ name: 'editUser', params: { email: record.email } })
    },
    newUser () {
      this.$router.push({ name: 'addUser' })
    }
  },
  created () {
    this.getUsers()
  }
}
</script>
